export default "/images/vendor/flag-icon-css/flags/4x3/in.svg?e5926cb75dcbb15638dae2af4b9abbcc";